"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountInternalRequestEntityToJSON = exports.AdAccountInternalRequestEntityFromJSONTyped = exports.AdAccountInternalRequestEntityFromJSON = exports.instanceOfAdAccountInternalRequestEntity = void 0;
var runtime_1 = require("../runtime");
var AdAccountSource_1 = require("./AdAccountSource");
var AdAccountTaxObject_1 = require("./AdAccountTaxObject");
var BillingAddress_1 = require("./BillingAddress");
/**
 * Check if a given object implements the AdAccountInternalRequestEntity interface.
 */
function instanceOfAdAccountInternalRequestEntity(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAccountInternalRequestEntity = instanceOfAdAccountInternalRequestEntity;
function AdAccountInternalRequestEntityFromJSON(json) {
    return AdAccountInternalRequestEntityFromJSONTyped(json, false);
}
exports.AdAccountInternalRequestEntityFromJSON = AdAccountInternalRequestEntityFromJSON;
function AdAccountInternalRequestEntityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : (0, AdAccountSource_1.AdAccountSourceFromJSON)(json['source']),
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'emailSubscribed': !(0, runtime_1.exists)(json, 'email_subscribed') ? undefined : json['email_subscribed'],
        'lead': !(0, runtime_1.exists)(json, 'lead') ? undefined : json['lead'],
        'leadId': !(0, runtime_1.exists)(json, 'lead_id') ? undefined : json['lead_id'],
        'invoiceEnabled': !(0, runtime_1.exists)(json, 'invoice_enabled') ? undefined : json['invoice_enabled'],
        'billToAddress': !(0, runtime_1.exists)(json, 'bill_to_address') ? undefined : (0, BillingAddress_1.BillingAddressFromJSON)(json['bill_to_address']),
        'taxIds': !(0, runtime_1.exists)(json, 'tax_ids') ? undefined : (json['tax_ids'].map(AdAccountTaxObject_1.AdAccountTaxObjectFromJSON)),
        'currencyCode': !(0, runtime_1.exists)(json, 'currency_code') ? undefined : json['currency_code'],
    };
}
exports.AdAccountInternalRequestEntityFromJSONTyped = AdAccountInternalRequestEntityFromJSONTyped;
function AdAccountInternalRequestEntityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'source': (0, AdAccountSource_1.AdAccountSourceToJSON)(value.source),
        'email': value.email,
        'email_subscribed': value.emailSubscribed,
        'lead': value.lead,
        'lead_id': value.leadId,
        'invoice_enabled': value.invoiceEnabled,
        'bill_to_address': (0, BillingAddress_1.BillingAddressToJSON)(value.billToAddress),
        'tax_ids': value.taxIds === undefined ? undefined : (value.taxIds.map(AdAccountTaxObject_1.AdAccountTaxObjectToJSON)),
        'currency_code': value.currencyCode,
    };
}
exports.AdAccountInternalRequestEntityToJSON = AdAccountInternalRequestEntityToJSON;
